import {
  Box,
  Button,
  Container,
  Paper,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import useList from "./useList";
import Template from "@/templates/Templates";

export const List = () => {
  const {
    templateList,
    handleGoToCreate,
    isLoading,
    handleFilterChange,
    selectedProductId,
  } = useList();

  return (
    <Container maxWidth={"xl"}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        gap={2}
        alignItems={"end"}
        mb={2}
      >
        <Typography
          component={"h1"}
          variant="h5"
          fontWeight={"bold"}
          gutterBottom
        >
          템플릿 목록
        </Typography>
        <Button
          variant={"contained"}
          disableElevation
          startIcon={<AddIcon />}
          onClick={handleGoToCreate}
        >
          템플릿 등록
        </Button>
      </Box>

      {/* 필터 버튼 영역 */}
      <Paper elevation={0} variant="outlined" sx={{ mb: 3 }}>
        <Box sx={{ p: 2 }}>
          <ToggleButtonGroup
            value={selectedProductId}
            exclusive
            onChange={(_, newValue) => newValue && handleFilterChange(newValue)}
            aria-label="상품 필터"
            fullWidth
            color="primary"
          >
            <ToggleButton value="1" aria-label="Starter">
              Starter
            </ToggleButton>
            <ToggleButton value="2" aria-label="Standard">
              Standard
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
      </Paper>

      {/* 템플릿 목록 */}
      <Template.List templateList={templateList} isLoading={isLoading} />
    </Container>
  );
};
